import React, { useMemo } from 'react';
import { SWRConfig } from 'swr';

import getApi from '../../../Utils/api';

interface ApiProps {
  token?: string;
  children?: React.ReactNode;
}

const Api: React.FC<ApiProps> = ({ token, children }) => {
  const fetcher = useMemo(() => getApi(token || ''), [token]);

  return (
    <SWRConfig
      value={{
        fetcher,
      }}
    >
      {children}
    </SWRConfig>
  );
};

export default Api;
